module.exports = __webpack_public_path__ + "static/media/welcome-page-header.40abf0e0.jpg";